// extracted by css-extract-rspack-plugin
export default {"fallback":"fallback-KKZ7kg","message":"message-JP1Fwz","delayed":"delayed-AOCsPI","lazyRouteReveal":"lazyRouteReveal-oSJ13b"};